import React from "react";

import { Stack } from "@mui/material";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Switch from "@src/sharedComponents/Switch/Switch";

import styles from "./TradingGroupsTable.module.css";

const LoadingTradingTableGroups = () => (
  <div className={styles.container}>
    <div className={styles.listHeaderDiv}>
      <div className={styles.flexDiv}>
        <Skeleton width={200} />
      </div>
    </div>

    <div className={styles.optionsDiv}>
      <div className={styles.half_width}>
        <Skeleton width={100} />
      </div>
      <div className={styles.divRight}>
        <Stack flex={1} flexDirection={"row"} justifyContent={"space-between"}>
          <Skeleton width={200} />
          <Skeleton width={15} />
        </Stack>
      </div>
    </div>

    <div className={styles.settingsDiv}>
      <div className={styles.half_width}>
        <Skeleton width={150} />
      </div>

      <div className={styles.half_width}>
        {new Array(3).fill(0).map((_, index) => (
          <div key={index} className={styles.flexApart}>
            <div className={styles.flexDiv}>
              <Skeleton width={120} />
            </div>
            <Switch disabled={true} on={false} onClick={() => {}} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default LoadingTradingTableGroups;
